import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { Input } from 'reactstrap';
import classnames from 'classnames';
import useReadOnly from './useReadOnly';

const Select = (props) => {
  const [field, meta] = useField(props);
  const readOnly = props.readOnly;

  let { name, options, invalid } = props;

  options = React.useMemo(
    () =>
      options?.filter((o) => {
        return readOnly ? !o.value || o.value === meta.value : !o.readOnly;
      }),
    [options, readOnly, meta.value]
  );

  return (
    <Input
      {...field}
      value={field.value || ''}
      id={name}
      type='select'
      disabled={readOnly}
      invalid={invalid || (meta.error && meta.touched)}
      className={classnames(props.className)}
    >
      {(options || []).map((o, i) => (
        <option key={`${o.value}_${i}`} value={o.value}>
          {o.label}
        </option>
      ))}
    </Input>
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      readOnly: PropTypes.bool,
    })
  ),
  readOnly: PropTypes.bool,
  invalid: PropTypes.any,
};

export default Select;
